import Vue from "vue";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../../Controls/ServicesFactory";
import { PrimoboxExerciceDto } from "../../../../dto/GenApi.iNotPaie.Dto/PrimoboxExerciceDto";
import dateHelper from "../../../../Helper/dateHelper";
import Component from "vue-class-component";
import { PrimoboxTraitementDetailDto } from "../../../../dto/GenApi.iNotPaie.Dto/PrimoboxTraitementDetailDto";
import { EventBus } from "../../../Controls/EventBus";
import { ModalAlerteOptions } from "../../../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../../../Controls/EventConstants";
import { PrimoboxEtatTraitement } from "../../../../dto/GenApi.iNotPaie.Dto/PrimoboxEtatTraitement";
import { PrimoboxTypeEnvoiTraitement } from "../../../../dto/GenApi.iNotPaie.Dto/PrimoboxTypeEnvoiTraitement";
import { PrimoboxNatureEnvoi } from "../../../../dto/GenApi.iNotPaie.Dto/PrimoboxNatureEnvoi";
import { primoboxHelper } from "../../primoboxHelper";

export interface PrimoboxTraitementDetailViewModel extends PrimoboxTraitementDetailDto {
	estSelectionne: boolean;
}

@Component
export default class ModalDetailsEnvoiBulletin extends Vue {
	public dataReady: boolean = false;
	public peutRedistribuer: boolean = false;
	public toutSelectionner?: boolean = false;
	public isAnySelected: boolean = false;
	
	public primoboxExercice?: PrimoboxExerciceDto;
	public primoboxDetails: PrimoboxTraitementDetailViewModel[] = [];

	// Initialisation du composant
	public Init(primoboxExercice: PrimoboxExerciceDto): void {
		this.dataReady = false;
		this.primoboxExercice = primoboxExercice;
		this.peutRedistribuer = primoboxExercice?.EtatEnum === PrimoboxEtatTraitement.Termine;
		this.toutSelectionner = !this.peutRedistribuer;
		this.isAnySelected = this.toutSelectionner;
		
		this.refresh();
	}

	public refresh(): void {
		this.dataReady = false;
		this.primoboxDetails = [];
		ServicesFactoryInstance.PrimoboxService.updatePrimoboxExercices({ idExercice: this.primoboxExercice!.IdExercice },
			(status) => {
				ServicesFactoryInstance.PrimoboxService.getPrimoboxTraitementDetails(this.primoboxExercice!.IdExercice, data => {
					this.primoboxDetails = this.getPrimoboxDetailViewModels(data, this.toutSelectionner ?? false);
					this.dataReady = true;
				}, () => this.dataReady = true);
			},
			(error) => {
				this.dataReady = true;
			}
		);
		
	}

	// Permet d'afficher le mois de l'exercice
	public DisplayMois(): string {
		let libelle:string = "";
		if (this.primoboxExercice != null && this.primoboxExercice.MoisExercice > 0) {
			libelle = dateHelper.geLibelleDateMois(this.primoboxExercice.MoisExercice);
		} else {
			libelle = "";
		}
		return libelle;
	}

	// Permet de faire la distribution des bulletins
	public distribuer(): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "En cliquant sur valider, les bulletins seront mis à disposition dans l'espace sécurisé des salariés.<br><br>Souhaitez - vous continuer ?",
			title: "CONFIRMATION DE LA DISTRIBUTION",
			callBackYes: (): void => {
				// Synchroniser et distribuer
				let idContrats: number[] = [];
				if (this.peutRedistribuer) {
					idContrats = this.primoboxDetails.filter(detail => detail.estSelectionne).map(detail => detail.IdContrat);
					this.$emit("SynchroniserAndRedistribuer", this.primoboxExercice, idContrats);
				} else {
					this.$emit("SynchroniserAndDistribuer", this.primoboxExercice);
				}

				$("#modalDetailsEnvoiBulletinComponent").modal("hide");
			},
			callBackNo: (): void => {
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	// Conversion des états en libellé
	public convertEtatToString(etat: PrimoboxEtatTraitement): string {
		return primoboxHelper.convertPrimoboxEtatToString(etat);
	}

	// Conversion des types d'envoi en libellé
	public convertTypeEnvoiToString(typeEnvoi: PrimoboxTypeEnvoiTraitement): string {
		let value = "";

		switch (typeEnvoi) {
			case PrimoboxTypeEnvoiTraitement.CoffreFort:
				value = "Coffre fort";
				break;
			case PrimoboxTypeEnvoiTraitement.Courrier:
				value = "Courrier";
				break;
		}

		return value;
	}

	// Ferme la modal
	public annuler(): void {
		$("#modalDetailsEnvoiBulletinComponent").modal("hide");
	}

	public toutSelectionnerChanged(): void {
		if (!this.primoboxDetails || this.toutSelectionner === undefined) {
			return;
		}
		this.primoboxDetails.forEach((detail) => {
			if (this.canRedistribuerContrat(detail)) {
				detail.estSelectionne = this.toutSelectionner ?? false;
			} else {
				detail.estSelectionne = false;
			}
		});
		this.isAnySelected = this.primoboxDetails.some(detail => detail.estSelectionne);
	}

	public estSelectionneChanged(): void {
		if (!this.primoboxDetails) {
			return;
		}

		if (this.primoboxDetails.every(detail => detail.estSelectionne)) {
			this.toutSelectionner = true;
			this.isAnySelected = true;
		} else if (this.primoboxDetails.every(detail => !detail.estSelectionne)) {
			this.toutSelectionner = false;
			this.isAnySelected = false;
		} else {
			this.toutSelectionner = undefined;
			this.isAnySelected = true;
		}
	}

	// Transforme la liste PrimoboxTraitementDetailDto en PrimoboxTraitementDetailViewModel
	public getPrimoboxDetailViewModels(primoboxTraitementDtoDetails: PrimoboxTraitementDetailDto[], estSelectionne: boolean): PrimoboxTraitementDetailViewModel[] {
		return primoboxTraitementDtoDetails.map(detail => ({
			...detail,
			estSelectionne: estSelectionne
		}));
	}

	public estRedistribution(ligne: PrimoboxTraitementDetailViewModel): boolean {
		return ligne?.NatureEnvoiEnum === PrimoboxNatureEnvoi.Selection;
	}

	// Permet de savoir le style de texte à afficher pour les états
	public canShowSimpleEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowSimpleEtat(etat);
	}

	public canShowAnomalieEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowAnomalieEtat(etat);
	}

	public canShowValiderEtat(etat: PrimoboxEtatTraitement): boolean {
		return primoboxHelper.canShowValiderEtat(etat);
	}

	public messageAnomalie(): void {
		primoboxHelper.messageAnomalie();
	}

	// Permet de valider l'envoi des bulletins de l'exercice
	public validerRedistribution(primoboxDetail: PrimoboxTraitementDetailViewModel): void {
		const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "En cliquant sur valider, vous ne pourrez plus modifier la redistribution des bulletins.<br><br>Souhaitez-vous continuer ?",
			title: "CONFIRMATION DE LA REDISTRIBUTION",
			callBackYes: (): void => {
				// Valider la redistribution
				this.$emit("validerRedistribution", primoboxDetail.IdTraitement);

				$("#modalDetailsEnvoiBulletinComponent").modal("hide");
			},
			callBackNo: (): void => {
			}
		});
		EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	// Permet de savoir si on peut redistribuer un contrat
	public canRedistribuerContrat(detail: PrimoboxTraitementDetailViewModel): boolean {

		return  detail.EtatEnum === PrimoboxEtatTraitement.Termine;
	}

	// Permet de savoir s'il existe une ligne sélectionnable pour redistribuer
	public anyDetailSelectable(): boolean {
		return this.primoboxDetails.some(detail => this.canRedistribuerContrat(detail));
    }
}



// WEBPACK FOOTER //
// ./src/components/Primobox/envoiBulletins/modalDetailsEnvoiBulletin/modalDetailsEnvoiBulletin.ts